import { isTMA } from '@web/libs/tg/platform'
import { useLayoutEffect, useState } from 'react'

export const WEB_SIDEBAR_WIDTH_PX = 284
export const WEB_PHONE_FRAME_MAX_WIDTH_PX = 540

export const WIDE_DESKTOP_MIN_WIDTH_PX = WEB_SIDEBAR_WIDTH_PX + WEB_PHONE_FRAME_MAX_WIDTH_PX

const wideDesktopQuery = `(min-width: ${WIDE_DESKTOP_MIN_WIDTH_PX}px)`

function isWideDesktopViewport(): boolean {
  if (typeof window === 'undefined') return false

  if (isTMA()) return false

  return window.matchMedia(wideDesktopQuery).matches
}

export function useWideDesktopLayout(): boolean {
  const [isWideDesktop, setIsWideDesktop] = useState(isWideDesktopViewport)

  useLayoutEffect(() => {
    const media = window.matchMedia(wideDesktopQuery)

    const onChange = () => {
      const wide = isWideDesktopViewport()
      setIsWideDesktop(wide)
      document.documentElement.toggleAttribute('data-wide-desktop', wide)
    }

    onChange()
    media.addEventListener('change', onChange)
    return () => {
      media.removeEventListener('change', onChange)
      document.documentElement.removeAttribute('data-wide-desktop')
    }
  }, [])

  return isWideDesktop
}
